// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__NxaOM","fileDisabled":"File_fileDisabled__2t8Vx"};